import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class popUpAvatars {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 0,
      autoHeight: true,
      320: {
        spaceBetween: 0,
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 20,
        clickable: true,
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
    })
  }
}

export default popUpAvatars
